module.exports = __webpack_public_path__ + "img/8.5169c093.jpg";